<script>
import Layout from "../../layouts/no-menu/main-no-menu";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import SalesLeads from "@/components/crm/sales-leads.vue";

import { crmMethods, crmComputed } from "@/state/helpers";

/**
 * Starter component
 */
export default {
    page: {
        title: "Sales Leads",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, SalesLeads },
    computed: {
        ...crmComputed,
    },
    data() {
        return {
            title: "Sales Leads",
            items: [],
        };
    },
    methods: {
        ...crmMethods,
    },
};
</script>
<template>
    <Layout>
        <PageHeader />
        <SalesLeads />
    </Layout>
</template>
